export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=408554066c1db8d02e95f9210f09064eaa9484696d&name=revalidateCommunity!'